module.exports = __webpack_public_path__ + "img/voice_n.fda2723c.svg";